<template>
  <el-row>
    <!-- <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="系统角色"
                   name="1"></el-tab-pane>
      <el-tab-pane label="管理角色"
                   name="2"></el-tab-pane>
    </el-tabs> -->
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="角色名:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="角色名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/role/add'"
                 type="primary"
                 @click="handleAdd">新 增</el-button>
      <el-button v-has="'/role/batch_del'"
                 type="primary"
                 @click="multipleDelete">批量删除</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table ref="settleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column fixed="left"
                         type="selection"
                         width="60">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :key="index"
                         :fixed="item.fixed"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'createTime'">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="420">
          <template slot-scope="scope">
            <el-col>
              <el-button v-has="'/role/edit'"
                         size="mini"
                         type="primary"
                         @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-has="'/role/edit'"
                         plain
                         size="mini"
                         type="primary"
                         @click="assignAuthPerm(scope.row)">操作权限</el-button>
              <el-button v-has="'/role/edit'"
                         plain
                         size="mini"
                         type="primary"
                         @click="assignAuthDep(scope.row)">部门权限</el-button>
              <el-button v-has="'/role/edit'"
                         plain
                         size="mini"
                         type="primary"
                         @click="assignAuthArea(scope.row)">设备权限</el-button>
              <el-button v-has="'/role/batch_del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </el-col>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :current="pagination.currentPage"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-role v-if="showRoleModal"
              :isShow="showRoleModal"
              :data="roleData"
              @handleClose="closeRoleModal"></add-role>
    <AssignAuth v-if="showAuthPermModal"
                :isShow="showAuthPermModal"
                :data="authData"
                @handleClose="closeAuthPermModal"></AssignAuth>
    <AssignDep v-if="showAuthDepModal"
               :isShow="showAuthDepModal"
               :data="authData"
               @handleClose="closeAuthDepModal"></AssignDep>
    <AssignArea v-if="showAuthAreaModal"
                :isShow="showAuthAreaModal"
                :data="authData"
                @handleClose="closeAuthAreaModal"></AssignArea>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddRole from '@/views/system/role/AddRole'
import AssignAuth from '@/views/system/role/AssignAuth'
import AssignDep from '@/views/system/role/AssignDep'
import AssignArea from '@/views/system/role/AssignArea'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddRole, AssignAuth, AssignDep, AssignArea, Pagination },
  data() {
    return {
      activeName: '1',
      searchForm: {
        name: ''
      },
      tiemArr: [],
      tableTitle: [
        {
          prop: 'name',
          name: '角色名称',
          fixed: 'left',
          width: 80
        },
        {
          prop: 'remark',
          name: '角色描述',
          width: 100
        },
        {
          prop: 'creator',
          name: '创建人',
          width: 100
        },
        {
          prop: 'created',
          name: '创建时间',
          width: 100
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加用户相关
      showRoleModal: false,
      roleData: {
        type: 'add'
      },
      // 分配权限相关
      showAuthPermModal: false,
      showAuthDepModal: false,
      showAuthAreaModal: false,
      authData: {
        id: '',
        role: ''
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { currentPage, perPage } = this.pagination
      fetch
        .getRoleList({
          currentPage: currentPage,
          perPage: perPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    handleClick() {
      this.getList()
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 新增
    handleAdd() {
      this.showRoleModal = true
      this.roleData = {
        type: 'add'
      }
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 设置资源权限
    assignAuthPerm(data) {
      this.showAuthPermModal = true
      this.authData = {
        id: data.id,
        role: data.name,
        tab: this.activeName
      }
    },
    closeAuthPermModal() {
      this.showAuthPermModal = false
    },
    // 设置部门权限
    assignAuthDep(data) {
      this.showAuthDepModal = true
      this.authData = {
        id: data.id,
        role: data.name,
        tab: this.activeName
      }
    },
    closeAuthDepModal() {
      this.showAuthDepModal = false
    },
    // 设置设备权限
    assignAuthArea(data) {
      this.showAuthAreaModal = true
      this.authData = {
        id: data.id,
        role: data.name,
        tab: this.activeName
      }
    },
    closeAuthAreaModal() {
      this.showAuthAreaModal = false
    },
    // 编辑
    handleEdit(data) {
      this.showRoleModal = true
      this.roleData = {
        type: 'edit',
        id: data.id
      }
    },
    // 关闭弹窗
    closeRoleModal(params) {
      if (params === 'refresh') {
        this.getList()
      }
      this.showRoleModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRole(data.id)
        })
        .catch(() => {})
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delRole(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择角色后重试')
      }
    },
    // 删除
    delRole(ids) {
      fetch.batchDelRole({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
